import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class UserService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private Url = 'api/user';  // URL to web api

    private userSubject = new BehaviorSubject<any>(null);
    public user$ = this.userSubject.asObservable();

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    setUserDet(user: any) {
        this.userSubject.next(user);
    }

    getUserDet() {
        return this.userSubject.value;
    }

    addUser(userData: any): Promise<any> {
        const url = `${this.Url}/addUser`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getUser(userData:any): Promise<any> {
        const url = `${this.Url}/getUser`;
        return this.http
            .post(url, $.param(userData),{ headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    deleteUser(userData: any): Promise<any> {
        const url = `${this.Url}/deleteUser`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    updateUser(userData: any): Promise<any> {
        const url = `${this.Url}/updateUser`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/userlist.service.ts